export enum EgmRCEnums {
  egmRcInfo = 'EgmRC/EgmRCInfo', // 取得EGM選單設定檔
  egmRcEventP = 'EgmRC/EgmRCEventP', // 取得EGM回報事件清單
  egmRcMeters = 'EgmRC/EgmRCMeters', // 取得EGM的帳目內值
  egmRcSettingS = 'EgmRC/EgmRCSettingS', // 取得SERVER儲存的設定內值
  egmRcSettingM = 'EgmRC/EgmRCSettingM', // 取得EGM回報的設定內值
  machineRcAction = 'EgmRC/MachineRCAction' // 遠端控制機台
}
